module.exports = __webpack_public_path__ + "img/aisfibre.f348efbc.png";